import React from 'react';
import { useIntl } from 'react-intl';

import { MinusIcon, PlusIcon } from './icons';
import { ZoomButton, ZoomControls as ZoomControlsContainer } from './styles';

interface FloorplanZoomControlsProps {
  canZoomIn: boolean;
  canZoomOut: boolean;
  onZoomIn: VoidFunction;
  onZoomOut: VoidFunction;
}

/** Zoom buttons pinned to the top-right of the map, as in the design. */
export const FloorplanZoomControls = ({
  canZoomIn,
  canZoomOut,
  onZoomIn,
  onZoomOut,
}: FloorplanZoomControlsProps): JSX.Element => {
  const intl = useIntl();

  return (
    <ZoomControlsContainer data-testid="floorplan-zoom-controls">
      <ZoomButton
        type="button"
        data-testid="floorplan-zoom-in"
        aria-label={intl.formatMessage({ id: 'zoomIn' })}
        disabled={!canZoomIn}
        onClick={onZoomIn}
      >
        <PlusIcon />
      </ZoomButton>
      <ZoomButton
        type="button"
        data-testid="floorplan-zoom-out"
        aria-label={intl.formatMessage({ id: 'zoomOut' })}
        disabled={!canZoomOut}
        onClick={onZoomOut}
      >
        <MinusIcon />
      </ZoomButton>
    </ZoomControlsContainer>
  );
};
